var de = {
  "Add Upsell.com to your ": "Upsell.com hinzufügen zu Ihrer ",
  "All time": "Gesamtzeit",
  "and select": "und wählen Sie",
  "button": "Button",
  "Cart drawer page": "Warenkorb-Schubladenseite",
  "Cart page": "Warenkorbseite",
  "Check status": "Status überprüfen",
  "Checkout page": "Checkout-Seite",
  "Click": "Klicken Sie auf",
  "Click on": "Klicken Sie auf",
  "Click the": "Klicken Sie auf den",
  "Custom slot": "Benutzerdefinierter Slot",
  "Custom slots": "Benutzerdefinierte Slots",
  "Custom Slots": "Benutzerdefinierte Slots",
  "contact support.": "kontaktieren Sie den Support.",
  "from the right sidebar": "aus der rechten Seitenleiste",
  "Go to your Cart drawer page": "Gehen Sie zu Ihrer Warenkorb-Schubladenseite",
  "Go to your Cart page": "Gehen Sie zu Ihrer Warenkorbseite",
  "Go to your Checkout page": "Gehen Sie zu Ihrer Checkout-Seite",
  "Go to your Order status page": "Gehen Sie zu Ihrer Bestellstatusseite",
  "Go to your Post purchase page": "Gehen Sie zu Ihrer Nach-dem-Kauf-Seite",
  "Go to your Product page": "Gehen Sie zu Ihrer Produktseite",
  "Go to your Thank you page": "Gehen Sie zu Ihrer Dankesseite",
  "items": "Artikel",
  "in the left sidebar": "in der linken Seitenleiste",
  "Last 12 months": "Letzte 12 Monate",
  "Last 30 days": "Letzte 30 Tage",
  "Last 365 days": "Letzte 365 Tage",
  "Last 7 days": "Letzte 7 Tage",
  "Last 90 days": "Letzte 90 Tage",
  "Last month": "Letzter Monat",
  "Last year": "Letztes Jahr",
  "Make sure": "Stellen Sie sicher",
  "Need assistance? Contact our support team for help.": "Brauchen Sie Hilfe? Kontaktieren Sie unser Support-Team.",
  "Order status page": "Bestellstatusseite",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Unsere App wird derzeit etwas optimiert, um Ihr Erlebnis zu verbessern.",
  "Post purchase page": "Nach-dem-Kauf-Seite",
  "Product page": "Produktseite",
  "Save": "Speichern",
  "Scroll to the bottom and select": "Scrollen Sie nach unten und wählen Sie",
  "Select": "Auswählen",
  "Success. Please continue.": "Erfolg. Bitte fahren Sie fort.",
  "Thank you page": "Dankesseite",
  "The Upsell.com team.": "Das Upsell.com-Team.",
  "The Upsell.com widget is not placed on ": "Das Upsell.com-Widget ist nicht auf ",
  ". Please follow the steps above or ": " platziert. Bitte folgen Sie den obigen Schritten oder ",
  "Today": "Heute",
  "toggle is on": "der Schalter ist an",
  "Total": "Gesamt",
  "under": "unter",
  "We apologize for any inconvenience caused,": "Wir entschuldigen uns für die Unannehmlichkeiten,",
  "We apologize for any inconvenience caused.": "Wir entschuldigen uns für die Unannehmlichkeiten.",
  "We'll be done in a few minutes!": "Wir sind in wenigen Minuten fertig!",
  "We're improving our services!": "Wir verbessern unsere Dienste!",
  "Widget already added": "Widget bereits hinzugefügt",
  "Yesterday": "Gestern",
  "You placed the widget on the ": "Sie haben das Widget auf ",
  ", but you didn't save it in Shopify editor. Please go back to ": " platziert, aber es nicht im Shopify-Editor gespeichert. Bitte gehen Sie zurück zu ",
  " and save the changes.": " und speichern Sie die Änderungen."
};

export { de as default };
//# sourceMappingURL=de.json.js.map
